import "./style.scss"

export default function LoadingDots() {
  return <div className="components_loading-dots"></div>
}
